<script setup lang="ts">
import { BarChart } from 'echarts/charts'
import { use } from 'echarts/core'
import VChart from 'vue-echarts'

import { useTimeChartDateFormat } from '~/composables/useTimeChartDateFormat'
import { CHART_TOOLTIP } from '~/environment-variables/chart.const'

interface IProps {
  data: [number, string][]
  color: string
  formatter: (params: any) => string
  height?: number
  tooltip?: any
}

const props = withDefaults(defineProps<IProps>(), {
  height: 300,
  tooltip: {
    backgroundColor: CHART_TOOLTIP.backgroundColor,
    textStyle: CHART_TOOLTIP.textStyle,
  },
})

const chartHeight = computed(() => {
  return `${props.height}px`
})

use([ BarChart ])

const { xAxisData, yAxisData } = useTimeChartDateFormat(props.data)

const barChartOption = {
  xAxis: {
    show: false,
    type: 'category',
    data: xAxisData,
  },
  yAxis: {
    show: false,
    type: 'value'
  },
  grid: {
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
  tooltip: {
    trigger: 'item',
    position: 'top',
    backgroundColor: props.tooltip.backgroundColor,
    padding: 8,
    borderWidth: 0,
    textStyle: props.tooltip.textStyle,
    formatter: props.formatter
  },
  series: [
    {
      barWidth: 10,
      itemStyle: {
        color: props.color,
        borderRadius: 10,
      },
      data: yAxisData,
      type: 'bar',
      emphasis: {
        focus: 'self',
      }
    }
  ]
}
</script>

<template>
  <VChart
    class="chart"
    :option="barChartOption"
    :style="{ height: chartHeight }"
    autoresize
  />
</template>

<style scoped>
</style>